<template>
  <div
    v-bind="$attrs"
    v-on="$listeners"
    :style="style.container"
  >
    <div :style="style.headerContainer">
      <SearchExpertBoxPrimary
        v-on="$listeners"
        v-model="tags"
        :disabled="viewOnly"
        :minWidthInput="'100px'"
        :placeholder="getSearchBoxPlaceholder"
        @filled="searchBoxFilled = true"
        @unfilled="searchBoxFilled = false"
        @focusin="searchBoxFocus = true"
        @focusout="searchBoxFocus = false"
        :style="getSearchBoxStyle"
      />
    </div>
    <div :style="style.subHeader">
      {{ subHeaderText }}
    </div>
    <CardPrimary :style="style.card">
      <template v-if="isLoading">
        <LoaderPrimary
          :loading="true"
          :style="style.loader"
        />
      </template>
      <template v-else>
        <div
          v-for="(tenantTeamTenantUser, index) in tenantTeamTenantUsers"
          :key="index"
        >
          <UserListRow
            :disabled="isRequesting"
            :tenantTeamTenantUser="tenantTeamTenantUser"
            :viewOnly="viewOnly"
            @mouseout="onMouseoutTenantUser"
            @mouseover="onMouseoverTenantUser"
            @select="tenantTeamTenantUser => selectTenantTeamTenantUser(tenantTeamTenantUser, true)"
            @unselect="tenantTeamTenantUser => selectTenantTeamTenantUser(tenantTeamTenantUser, false)"
          />
          <div :style="style.divider" />
        </div>
      </template>
    </CardPrimary>
  </div>
</template>

<script>
  import ApiTenantTeamTenantUser from '@js/api/tenant-team-tenant-user'
  import CardPrimary from '@modules/card/card-primary'
  import LoaderPrimary from '@modules/loader/loader-primary'
  import SearchExpertBoxPrimary from '@modules/v2/input/search-expert-box-primary'
  import UserListRow from '@teamup/modules/user-list-row'
  import { FontStyle, Layout } from '@js/styles'
  import { Z_INDEXES } from '@js/constants'
  import { mapGetters } from 'vuex'

  const tabPrimaryHeight = '21px';
  const userListHeaderHeight = '68px';
  const userListSubHeaderHeight = '24px';

  export default {
    name: 'UserList',
    inheritAttrs: false,
    components: {
      CardPrimary,
      LoaderPrimary,
      SearchExpertBoxPrimary,
      UserListRow,
    },
    props: {
      isLoading: {
        type: Boolean,
        required: false,
        default: false,
      },
      tenantTeam: {
        type: Object,
        required: false,
        default: () => {},
      },
      tenantTeamTenantUsers: {
        type: Array,
        required: false,
        default: () => [],
      },
      viewOnly: {
        type: Boolean,
        required: false,
        default: true,
      },
    },
    data: function () {
      return {
        isRequesting: false,
        searchBoxFocus: false,
        searchBoxFilled: false,
        tags: [],
        style: {
          card: {
            height: `calc(100% - ${userListHeaderHeight} - ${userListSubHeaderHeight})`,
            overflowY: 'scroll',
            width: '100%',
          },
          container: {
            height: `calc(100% - ${tabPrimaryHeight})`,
            width: '100%',
          },
          divider: {
            height: '1px',
            width: '100%',
          },
          headerContainer: {
            alignItems: 'center',
            display: 'flex',
            height: userListHeaderHeight,
            justifyContent: 'flex-start',
            width: '100%',
          },
          loader: {
            height: '100%',
            width: '100%',
          },
          subHeader: {
            fontSize: FontStyle.size.sm,
            fontWeight: FontStyle.weight.lg,
            height: Layout.space.md,
            margin: `0 0 ${Layout.space.sm} 0`,
          },
        },
      };
    },
    created: function () {
      this.style.divider = {
        ...this.style.divider,
        backgroundColor: this.color.dark5(),
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      getSearchBoxPlaceholder: function () {
        return this.searchBoxFocus ? 'Enter any keywords' : 'Add members';
      },
      getSearchBoxStyle: function () {
        return {
          flex: 1,
          maxWidth: this.searchBoxFocus || this.searchBoxFilled ? '100%' : '180px',
          zIndex: Z_INDEXES.TEAMUP.SEARCH_BOX,
        };
      },
      subHeaderText: function () {
        return `Shown members: ${this.tenantTeamTenantUsers.filter(elem => elem.selected).length}`;
      },
    },
    methods: {
      onMouseoutTenantUser: function (tenantUserId) {
        this.$emit('mouseout-tenant-user', tenantUserId);
      },
      onMouseoverTenantUser: function (tenantUserId) {
        this.$emit('mouseover-tenant-user', tenantUserId);
      },
      selectTenantTeamTenantUser: async function (tenantTeamTenantUser, selected) {
        if (this.viewOnly) {
          return;
        }

        try {
          this.isRequesting = await true;
          const payload = await { selected: selected };
          const api = await new ApiTenantTeamTenantUser(
              this.tenantTeam.id, tenantTeamTenantUser.id);
          const res = await api.put(payload);

          if (selected) {
            await this.$emit('selected', res.data);
          } else {
            await this.$emit('unselected', res.data);
          }
          this.isRequesting = await false;
        } catch (error) {
          this.isRequesting = false;
          console.error(error);
        }
      },
    },
  };
</script>

